export default __webpack_public_path__ + "static/media/header_banner_image.25126e93.png";